export const home = {
  heroTitle: '實物黃金',
  heroSubtitle: '現貨預約',
  heroMainTitle: '每筆訂單對應一筆現貨黃金',
  heroTitleLine1: '實物黃金，透明可溯',
  heroTitleLine2: '安全放心，財富傳承',
  heroSubTags: '實物黃金 · 透明可溯 · 安全放心',
  heroDesc: '以當日金價鎖定價格，到期提取實物黃金',
  heroCta: '立即鎖價',
  productLabel: '投資金條',
  productWeight: '50g',
  productBrand: 'Au9999',
  guaranteePhysicalGold: '實物保障',
  guaranteePhysicalGoldDesc: '100%實物黃金',
  guaranteeAuthority: '權威認證',
  guaranteeAuthorityDesc: '國檢認證 | 品質保障',
  guaranteeTransparency: '安全透明',
  guaranteeTransparencyDesc: '信息公開 | 透明合規',
  physicalGuaranteeBadge: '實物保障',
  realGold: 'REAL GOLD',
  liveGoldPrice: '實時金價（Au9999）',
  liveUpdate: '實時更新',
  todayChange: '今日漲幅',
  moreMarket: '更多行情',
  marketRefTitle: '市場參考價',
  shGoldExchange: '上海黃金交易所 Au9999',
  shSilverExchange: '上海白銀交易所 Ag9999',
  todayGoldRef: '今日金價參考',
  todaySilverRef: '今日銀價參考',
  quickReserve: '快速預約',
  reserveOrders: '預約訂單',
  performManage: '履約管理',
  performPay: '履約支付',
  quickReserveDesc: '即時鎖定價格',
  reserveOrdersDesc: '隨時查看進度',
  performManageDesc: '實物保障放心',
  performPayDesc: '安全便捷無憂',
  jinanPromise: '金安承諾',
  promiseValues: '專業 · 誠信 · 安全 · 透明',
  promiseSubtitle: '您的黃金資產，交給金安中國',
  marketRefAu: '市場參考價 Au9999',
  marketRefAg: '市場參考價 Ag9999',
  noticeTitle: '金安公告',
  serviceGuarantee: '預約服務 · 實物保障',
  guaranteeSecurity: '安全保障',
  guaranteeSecurityDesc: '銀行級安全體系',
  guaranteeTransparent: '透明交易',
  guaranteeTransparentDesc: '即時行情公開透明',
  guaranteePhysical: '實物交割',
  guaranteePhysicalDesc: '到期可提取實物黃金',
  guaranteeService: '專業服務',
  guaranteeServiceDesc: '24小時客服在線',
  footerBrand: '金安中國',
  footerCopyright: '© 2026 金安中國. Physical Gold Custody & Security Guaranteed.',
  physicalGold: 'PHYSICAL GOLD',
  spotReserve: '現貨預約',
  openPrice: '開倉價',
  currentPrice: '現價',
  profitLoss: '盈虧',
  buyIn: '買入 IN',
  sellOut: '賣出 OUT',
  originalMargin: '原始保證金',
  currentMargin: '當前保證金',
  deferredFee: '延期費',
  riskLevel: '風險度',
  paidIn: '已補',
  paidOut: '已折',
  depositRecord: '訂金記錄',
  applyPerform: '申請履約',
  addDeposit: '補定金',
  withdrawDeposit: '拆定金',
  closePosition: '平倉',
  availableMargin: '可用定金',
  usedMargin: '已用定金',
  floatingProfit: '浮動盈虧',
  longWeight: '多',
  shortWeight: '空',
  netWeight: '淨',
  noPosition: '暫無持倉',
  noCloseRecord: '暫無平倉記錄',
  positionLoadFailed: '持倉資料載入失敗',
  confirmDeposit: '確認補入',
  confirmWithdraw: '確認拆出',
  confirmClose: '確認平倉',
  cancelClose: '取消',
  closeWarning: '平倉後將立即結算盈虧，該持倉不可恢復。確認平倉前請仔細核對以上資訊。',
  depositAmount: '補入金額',
  withdrawAmount: '拆出金額',
  currentDeposit: '當前保證金',
  availableDeposit: '可用定金',
  withdrawable: '可拆金額',
  keep10Percent: '需保留原始保證金的 10% 作為最低保證金',
  quickAmount1000: '¥1000',
  quickAmount3000: '¥3000',
  quickAmount5000: '¥5000',
  quickAmount10000: '¥10000',
  allAmount: '全部',
  maxAmount: '最大',
  errorInvalidAmount: '請輸入有效的金額',
  errorInsufficientFunds: '可用定金不足',
  errorMaxWithdraw: '最多可拆 ¥{{amount}}（需保留10%原始保證金）',
  expectedProfit: '預計盈虧',
  openPriceLabel: '開倉價',
  closePriceLabel: '平倉價',
  holdTab: '持倉',
  closeTab: '平倉',
  selectAll: '全選',
};